
import PublicService from "@/services/public.service";

/**
 * @classdesc Les champs du formulaire d'identité d'une inscription coureur
 * @kind class
 * @export
 * @prop {array} ids_parcours - Liste des ids des parcours selectionnés
 * @class List_Champs_Formulaire
 */
export default class List_Champs_Formulaire {
  list_ids_parcours = [];
  id_module;
  list = [];
  /**
   * Creates an instance of List_Champs_Formulaire.
   * @constructs
   * @kind function
   * @memberof List_Champs_Formulaire
   */
  constructor() { }

  async fetch(group_fields = false, billetterie = false) {

    let res = await PublicService.getChampsFormulaire(this.id_module);
    if (!res) return false;
    if (group_fields) {
      this.keepOnlyGroupeFields(res);
    }
    else {
      this.set(res, billetterie);
    }
    return true;

  }


  set(data, billetterie, hide_sexe_birthdate_fields = false) {

    this.list = [];
    let champs = data.list_generaux.concat(data.list_specifiques);

    for (let i = 0; i < data.list_liaisons_champs_course.length; i++) {
      let course = data.list_liaisons_champs_course[i];

      if (this.list_ids_parcours.includes(course.id_course)) {
        let champs_course = course.list_generaux.concat(course.list_specifiques);
        for (let j = 0; j < champs_course.length; j++) {
          if (champs_course[j].demande == "0") {
            continue;
          }
          let is_existing = this.exist(champs_course[j].id_champ);
          if (!is_existing) {
            for (let k = 0; k < champs.length; k++) {
              if (champs[k].id == champs_course[j].id_champ) {
                champs[k].mandatory = champs_course[j].mandatory;
                this.list.push(champs[k]);
                break;
              }
            }
          }
          else {
            if (champs_course[j].mandatory > this.list[is_existing].mandatory) {
              this.list[is_existing].mandatory = champs_course[j].mandatory;
            }
          }
        }
      }
    }
    // Si aucun champ n'est défini pour le parcours, on prend les champs par défaut obligatoire du module
    if (this.list.length == 0 && !billetterie) {
      this.set_default_mandatory_champs(data);
    }
    // Si c'est un module de billetterie, on prend les champs par défaut 
    else if (this.list.length == 0 && billetterie) {
      this.set_default_champs(data, hide_sexe_birthdate_fields);
    }


  }

  set_default_mandatory_champs(data) {
    for (let i = 0; i < data.list_generaux.length; i++) {
      if (data.list_generaux[i].mandatory == "1") {
        this.list.push(data.list_generaux[i]);
      }
    }
  }

  set_default_champs(data, hide_sexe_birthdate_fields) {
    let defaults = ["nom", "prenom", "sexe", "date_naissance", "mail", "telephone", "ville", "volvic_50"];
    for (let i = 0; i < data.list_generaux.length; i++) {
      if (defaults.includes(data.list_generaux[i].nom)) {
        if (hide_sexe_birthdate_fields && (data.list_generaux[i].nom == "sexe")) {
          continue;
        }
        this.list.push(data.list_generaux[i]);
      }
    }
  }

  exist(id) {
    for (let i = 0; i < this.list.length; i++) {
      if (this.list[i].id == id) {
        return i;
      }
    }
    return false;
  }

  keepOnlyGroupeFields(data) {
    let fields_group = ["mail", "telephone", "club", "cp", "ville", "contact_urgence", "tel_contact_urgence"];
    let champs = data.list_generaux.concat(data.list_specifiques);
    for (let i = 0; i < champs.length; i++) {
      if (fields_group.includes(champs[i].nom)) {
        this.list.push(champs[i]);
      }
    }
  }
}